export const ATUALIZAR_ERRATA = 'ATUALIZAR_ERRATA';
export const atualizarErrata = (errata) => ({
  type: ATUALIZAR_ERRATA,
  payload: {
    errata,
  },
});
export const SELECT_ERRATA = 'SELECT_ERRATA';
export const selectErrata = (selectErrata) => ({
  type: SELECT_ERRATA,
  payload: {
    selectErrata,
  },
});




// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/erratas/erratas.action.js